import React from 'react';
import { motion } from 'framer-motion';
import { BarChart2 } from 'lucide-react';
import { StatisticsOverview } from './overview/StatisticsOverview';
import { StatisticsCharts } from './charts/StatisticsCharts';
import { StatisticsInsights } from './insights/StatisticsInsights';
import { TrendAnalysis } from './trends/TrendAnalysis';
import { useProducts } from '../../context/ProductContext';

export const StatisticsContainer: React.FC = () => {
  const { products, loading, error } = useProducts();

  if (loading) {
    return (
      <div className="text-center py-12">
        <BarChart2 className="mx-auto text-orange-300 animate-spin mb-4" size={48} />
        <p className="text-gray-600">Cargando estadísticas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 text-red-600 p-6 rounded-lg">
        {error}
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-lg shadow-lg p-6"
      >
        <div className="flex items-center gap-3 mb-6">
          <BarChart2 className="text-orange-500" size={24} />
          <div>
            <h2 className="text-xl font-bold">Análisis de Mercadona</h2>
            <p className="text-sm text-gray-600">
              Estadísticas detalladas y tendencias de productos
            </p>
          </div>
        </div>

        <div className="space-y-8">
          <StatisticsOverview products={products} />
          <TrendAnalysis products={products} />
          <StatisticsCharts products={products} />
          <StatisticsInsights products={products} />
        </div>
      </motion.div>
    </div>
  );
};